module.exports = __webpack_public_path__ + "img/menu-coolant-icon.9a5152b5.png";